import { createServerFn } from "@tanstack/react-start";
import { blogSlug, blogAuthorInput, blogAuthorId, type BlogAuthorRecord } from "./blogPublishing";
import { publicArticleClient } from "./flywheelArticles.functions";

export const getBlogCredit = createServerFn({ method: "GET" })
  .inputValidator((value: unknown) => blogSlug.parse(value))
  .handler(async ({ data: slug }) => {
    const client = publicArticleClient();
    const { data, error } = await client.from("blog_article_credits")
      .select("cover_image_url,og_image_url,blog_authors(*)").eq("slug", slug).maybeSingle();
    if (error) throw new Error("Could not read article credit");
    const parsed = blogAuthorInput.safeParse(Array.isArray(data?.blog_authors) ? data.blog_authors[0] : data?.blog_authors);
    if (parsed.success) return { cover: data?.cover_image_url ?? null, og: data?.og_image_url ?? null, author: parsed.data };
    const { data: article, error: articleError } = await client.from("flywheel_articles").select("author_id").eq("slug", slug).eq("status", "published").maybeSingle();
    if (articleError) throw new Error("Could not read article author");
    const { data: author, error: authorError } = await client.from("blog_authors").select("*").eq("id", blogAuthorId(article?.author_id)).eq("active", true).maybeSingle();
    if (authorError) throw new Error("Could not read default author");
    const fallback = blogAuthorInput.safeParse(author);
    return { cover: data?.cover_image_url ?? null, og: data?.og_image_url ?? null, author: fallback.success ? fallback.data : null };
  });

export const getBlogAuthors = createServerFn({ method: "GET" }).handler(async () => {
  const rows: BlogAuthorRecord[] = [];
  for (let offset = 0; ; offset += 500) {
    const { data, error } = await publicArticleClient().from("blog_authors").select("*").eq("active", true).order("id").range(offset, offset + 499);
    if (error) throw new Error("Could not read authors");
    rows.push(...(data ?? []) as BlogAuthorRecord[]);
    if (!data || data.length < 500) return rows;
  }
});